import { AxiosInstance } from 'axios';
import { DictionarysPoints, Dictionary } from './types';

const getPfdodDiseasesData = (api: AxiosInstance) => ({
  getPfdodDiseases: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.PFDOD_DISEASES);
    return data;
  },
});

const getActivityLevelData = (api: AxiosInstance) => ({
  getActivityLevel: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.ACTIVITY_LEVEL);
    return data;
  },
});

const getActivityMemberData = (api: AxiosInstance) => ({
  getActivityMember: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.ACTIVITY_MEMBER);
    return data;
  },
});

const getNokoCompetitionLevelsData = (api: AxiosInstance) => ({
  getNokoCompetitionLevels: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.NOKO_COMPETITION_LEVELS);
    return data;
  },
});

const getNokoCompetitionTypesData = (api: AxiosInstance) => ({
  getNokoCompetitionTypes: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.NOKO_COMPETITION_TYPES);
    return data;
  },
});

const getNokoProgressResultData = (api: AxiosInstance) => ({
  getNokoProgressResult: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.NOKO_PROGRESS_RESULT);
    return data;
  },
});

const getEducationFormData = (api: AxiosInstance) => ({
  getEducationForm: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EDUCATION_FORM);
    return data;
  },
});

const getEducationCategoriesData = (api: AxiosInstance) => ({
  getEducationCategories: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EDUCATION_CATEGORIES);
    return data;
  },
});

const getEducationModesData = (api: AxiosInstance) => ({
  getEducationModes: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EDUCATION_MODES);
    return data;
  },
});

const getApplicationTypesData = (api: AxiosInstance) => ({
  getApplicationTypes: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.APPLICATION_TYPES);
    return data;
  },
});

const getApplicationStatesDataData = (api: AxiosInstance) => ({
  getApplicationStatesData: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.APPLICATION_STATES);
    return data;
  },
});

const getUserEduLevelData = (api: AxiosInstance) => ({
  getUserEduLevel: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.USER_EDU_LEVEL);
    return data;
  },
});
const getConsultationsTopicData = (api: AxiosInstance) => ({
  getConsultationsTopic: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.CONSULTATIONS_TOPIC);
    return data;
  },
});
const getProfSpheresData = (api: AxiosInstance) => ({
  getProfSpheres: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.USER_PROF_SPHERES);
    return data;
  },
});

const getCompetencesData = (api: AxiosInstance) => ({
  getCompetences: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.USER_COMPETENCES);
    return data;
  },
});

const getProgrammTypesData = (api: AxiosInstance) => ({
  getProgrammTypes: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.PROGRAMM_TYPES);
    return data;
  },
});

const getWorkTypesData = (api: AxiosInstance) => ({
  getWorkTypes: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.WORK_TYPE);
    return data;
  },
});

const getSpheresTypesData = (api: AxiosInstance) => ({
  getSpheresTypes: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.WORK_SPHERES);
    return data;
  },
});

const getProfStandartsData = (api: AxiosInstance) => ({
  getProfStandarts: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.PROF_STANDARS);
    return data;
  },
});

const getWorkPlacesData = (api: AxiosInstance) => ({
  getWorkPlaces: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.WORK_PLACES);
    return data;
  },
});

const getPayLevelsData = (api: AxiosInstance) => ({
  getPayLevels: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.PAY_LEVELS);
    return data;
  },
});

const getEducationLevelsData = (api: AxiosInstance) => ({
  getEducationLevels: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EDUCATION_LEVELS);
    return data;
  },
});

const getEducationLevel = (api: AxiosInstance) => ({
  getEducationLevelDict: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EDUCATION_LEVEL);
    return data;
  },
});

const getDriverLicense = (api: AxiosInstance) => ({
  getDriverLicenseDict: async ():Promise<Dictionary> => {
    const {data} = await api.get(DictionarysPoints.DRIVER_LICENSE);
    return data
  }
})

const getWorldLanguage = (api: AxiosInstance) => ({
  getWorldLanguageDict: async ():Promise<Dictionary> => {
    const {data} = await api.get(DictionarysPoints.WORLD_LANGUAGES);
    return data
  }
})

const getLanguageLevel = (api: AxiosInstance) => ({
  getLanguageLevelDict: async ():Promise<Dictionary> => {
    const {data} = await api.get(DictionarysPoints.LANGUAGE_LEVEL);
    return data
  }
})

const getEducationType = (api: AxiosInstance) => ({
  getEducationTypeDict: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EDUCATION_TYPE);
    return data;
  },
});

const getVacanciesPlaceTypeData = (api: AxiosInstance) => ({
  getVacanciesPlaceType: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.VACANCIES_PLACE_TYPE);
    return data;
  },
});

const getVacanciesEmploymentTypeData = (api: AxiosInstance) => ({
  getVacanciesEmploymentType: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.VACANCIES_EMPLOYMENT_TYPE);
    return data;
  },
});

const getIndastriesData = (api: AxiosInstance) => ({
  getIndastries: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.PROF_INDASTRIES);
    return data;
  },
});

// Временная копипаста, оптимизировать, переделать
const getProfSpheresUnpublishedData = (api: AxiosInstance) => ({
  getUnpublishedProfSpheres: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.USER_PROF_SPHERES, {
      params: { unpublished: 1 },
    });
    return data;
  },
});

const getCompetencesUnpublishedData = (api: AxiosInstance) => ({
  getUnpublishedCompetences: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.USER_COMPETENCES, {
      params: { unpublished: 1 },
    });
    return data;
  },
});

const getProfessionsUnpublishedData = (api: AxiosInstance) => ({
  getUnpublishedProfessions: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.USER_PROFESSIONS, {
      params: { unpublished: 1 },
    });
    return data;
  },
});

const getEduDurationsData = (api: AxiosInstance) => ({
  getEduDurations: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EDUCATION_DURATIONS);
    return data;
  },
});
const getRegionsData = (api: AxiosInstance) => ({
  getRegions: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.REGIONS);
    return data;
  },
});

const getBlogEventTypesData = (api: AxiosInstance) => ({
  getBlogEventTypes: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.BLOG_EVENT_TYPES);
    return data;
  },
});

const getActivityOrderEduLevelData = (api: AxiosInstance) => ({
  getActivityOrderEduLevel: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.ACTIVITY_ORDER_EDU_LEVEL_SPR);
    return data;
  },
});

const eventOrderEduLevelsData = (api: AxiosInstance) => ({
  getEventOrderEduLevels: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EVENT_ORDER_EDU_LEVELS);
    return data;
  },
});

const partnerRoleDictData = (api: AxiosInstance) => ({
  getPartnerRoleDictData: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.PARTNER_ROLE_DICT);
    return data;
  },
});

const workSchedule = (api: AxiosInstance) => ({
  getWorkScheduleData: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.WORK_SCHEDULE_DICT);
    return data;
  },
});

const getEmployment = (api: AxiosInstance) => ({
  getEmploymentData: async (): Promise<Dictionary> => {
    const { data } = await api.get(DictionarysPoints.EMPLOYMENT_DICT);
    return data;
  },
});
// конец решения

// const getMentoringRequestStatusesData = (api: AxiosInstance) => ({
//   getMentoringRequestStatuses: async (): Promise<Dictionary> => {
//     const { data } = await api.get(
//       DictionarysPoints.MENTORING_REQUEST_STATUSES,
//     );
//     return data;
//   },
// });

// const getMentoringProgramStatusesData = (api: AxiosInstance) => ({
//   getMentoringProgramStatuses: async (): Promise<Dictionary> => {
//     const { data } = await api.get(
//       DictionarysPoints.MENTORING_PROGRAM_STATUSES,
//     );
//     return data;
//   },
// });

// const getMentoringMeetingStatusesData = (api: AxiosInstance) => ({
//   getMentoringMeetingStatuses: async (): Promise<Dictionary> => {
//     const { data } = await api.get(
//       DictionarysPoints.MENTORING_MEETING_STATUSES,
//     );
//     return data;
//   },
// });

// const getMentoringMeetingTypesData = (api: AxiosInstance) => ({
//   getMentoringMeetingTypes: async (): Promise<Dictionary> => {
//     const { data } = await api.get(DictionarysPoints.MENTORING_MEETING_TYPES);
//     return data;
//   },
// });

// const getMentoringMeetingFormatData = (api: AxiosInstance) => ({
//   getMentoringMeetingFormat: async (): Promise<Dictionary> => {
//     const { data } = await api.get(DictionarysPoints.MENTORING_MEETING_FORMAT);
//     return data;
//   },
// });

// const getMentoringTypesData = (api: AxiosInstance) => ({
//   getMentoringTypes: async (): Promise<Dictionary> => {
//     const { data } = await api.get(DictionarysPoints.MENTORING_TYPES);
//     return data;
//   },
// });

const dictionaryService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getWorkTypesData(api),
    ...getPayLevelsData(api),
    ...getWorkPlacesData(api),
    ...getIndastriesData(api),
    ...getProfSpheresData(api),
    ...getCompetencesData(api),
    ...getUserEduLevelData(api),
    ...getConsultationsTopicData(api),
    ...getSpheresTypesData(api),
    ...getEduDurationsData(api),
    ...getPfdodDiseasesData(api),
    ...getActivityLevelData(api),
    ...getEducationFormData(api),
    ...getProgrammTypesData(api),
    ...getProfStandartsData(api),
    ...getActivityMemberData(api),
    ...getEducationModesData(api),
    ...getEducationLevelsData(api),
    ...getEducationLevel(api),
    ...getEducationType(api),
    ...getApplicationTypesData(api),
    ...getNokoProgressResultData(api),
    ...getVacanciesPlaceTypeData(api),
    ...getEducationCategoriesData(api),
    ...getNokoCompetitionTypesData(api),
    ...getNokoCompetitionLevelsData(api),
    ...getApplicationStatesDataData(api),
    ...getProfSpheresUnpublishedData(api),
    ...getCompetencesUnpublishedData(api),
    ...getProfessionsUnpublishedData(api),
    ...getVacanciesEmploymentTypeData(api),
    ...getRegionsData(api),
    ...getBlogEventTypesData(api),
    ...getActivityOrderEduLevelData(api),
    ...eventOrderEduLevelsData(api),
    ...partnerRoleDictData(api),
    ...workSchedule(api),
    ...getEmployment(api),
    ...getDriverLicense(api),
    ...getLanguageLevel(api),
    ...getWorldLanguage(api),
    // ...getMentoringRequestStatusesData(api),
    // ...getMentoringProgramStatusesData(api),
    // ...getMentoringMeetingStatusesData(api),
    // ...getMentoringMeetingTypesData(api),
    // ...getMentoringMeetingFormatData(api),
    // ...getMentoringTypesData(api),
  };
};

export default dictionaryService;



// WEBPACK FOOTER //
// ./src/services/dictionary/dictionaryService.ts